import ApplicationLayout from 'components/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import SignUpForm from 'components/SignUpForm';
import LoginSignupLayout from 'components/LoginSignupLayout';

type Props = {
  currentPage: string;
  locationSlug: string;
  redirectTo: string;
};

export default function SignUp({ currentPage, locationSlug, redirectTo }: Props) {
  return (
    <CustomProvider>
      <ApplicationLayout currentPage={currentPage} locationSlug={locationSlug}>
        <LoginSignupLayout isSignupPage>
          <SignUpForm redirectTo={redirectTo} />
        </LoginSignupLayout>
      </ApplicationLayout>
    </CustomProvider>
  );
}
